import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { handleAxiosError } from "./servicesUtils";
import { PORTAL } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
//@ts-ignore
var baseUrl = window["_baseURLIt"];
var baseController = "".concat(baseUrl, "/rest/realEstate");
export var getRealEstateNotes = realEstateId => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseUrl, "/rest/publicUser/getRealEstateNotes/").concat(realEstateId));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return "";
  }
});
export var saveSearch = function saveSearch(email, title, hourly, resb) {
  var pushNotifications = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return __awaiter(void 0, void 0, void 0, function* () {
    if (!email || !resb) throw "Email or resb are not valid, ".concat(email, ", ").concat(resb);
    //TODO: solo per testing dato che bisogna chiedere il consenso all'utente
    return yield axios.post("".concat(baseController, "/saveSearch?email=").concat(email, "&title=").concat(title, "&hourly=").concat(hourly, "&pushNotifications=").concat(pushNotifications), resb);
    // return await axios.post(`${baseController}/saveSearch?email=${email}&title=${title}&hourly=${hourly}`, resb);
  });
};
export var saveSearchFromRequest = function saveSearchFromRequest(email, searchBean) {
  var pushNotifications = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return __awaiter(void 0, void 0, void 0, function* () {
    try {
      var title = "Ricerca salvata";
      //TODO: solo per testing dato che bisogna chiedere il consenso all'utente
      var res = yield axios.post("".concat(baseController, "/saveSearch?email=").concat(email, "&title=").concat(title, "&pushNotifications=").concat(pushNotifications), searchBean);
      // const res = await axios.post(`/rest/realEstate/saveSearch?email=${email}`, searchBean);
      return res.data;
    } catch (error) {
      handleAxiosError(error);
      throw error;
    }
  });
};
export var getRealEstateCounter = resb => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  var tempSB = deepCopy(resb);
  if (!tempSB) return null;
  /* Use polygon for DB only if it already set */
  if (tempSB.polygonForDB) {
    tempSB.polygonFromMap = tempSB.polygonForDB || "";
  }
  /* SOREX: BRUTAL FIX COUNTER NUOVE COSTRUZIONI */
  if ((_a = tempSB.listingTypologyIdList) === null || _a === void 0 ? void 0 : _a.includes(15)) {
    tempSB.conditionType = 5;
  }
  tempSB.portal = PORTAL.WIKICASA;
  var res = yield axios.post("/rest/realEstate/countRealEstateES", tempSB);
  return yield res.data;
});
export var getRealEstatesData = ids => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseUrl, "/rest/realEstate/getRealEstateListForInfoWindow/").concat(window["_locale"]), ids);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    return null;
  }
});
export var getMapMarkers = () => __awaiter(void 0, void 0, void 0, function* () {
  if (!window["_serializedSearchBean"]) return [];
  var searchBean = deepCopy(JSON.parse(window["_serializedSearchBean"]));
  delete searchBean["latitude"];
  delete searchBean["longitude"];
  try {
    var res = yield axios.post("".concat(baseUrl, "/rest/realEstate/getMapMarkers"), searchBean, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw [];
  }
});
export var getMortgageData = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/getFacileData"), data);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getPreviousNextRealEstate = (realEstateSearchBean, pageNumber) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/previousNextRealEstate"), realEstateSearchBean, {
      headers: {
        "Content-Type": "application/json",
        baseURL: window["_baseURL"],
        pageNumber
      }
    });
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getPreviousNextRealEstateDirect = realEstateSearchBean => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/previousNextRealEstateDirect"), realEstateSearchBean, {
      headers: {
        "Content-Type": "application/json",
        baseURL: window["_baseURL"]
      }
    });
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getSimilarRealEstateByREString = (realEstate, offset) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("/rest/realEstate/getSimilarRealEstate?offset=".concat(offset, "&limit=4"), realEstate);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});